<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="6">
                <b-card>
                    <div slot="header">
                        {{Core.Definition.getDefinition('Carte de crédit')}}<br/>
                        <small>
                            {{Core.Definition.getDefinition('')}}
                        </small>
                    </div>
                    <b-row>
                        <b-col>
                            <CCDefault v-if="Core.Validation.isId(userId)" :entityId="userId" entityType="user"></CCDefault>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import CCDefault from '../../../components/CCDefault'
    export default {
        name: 'UserSettingsPaymentMethods',
        components: {
            CCDefault
        },
        mounted() {
            if (Core.Validation.isId(this.$route.params.id)) {
                this.userId = this.$route.params.id
            } else {
                this.userId = Core.Session.AuthUser.id
            }
        },
        data: function () {
            return {
                Core: window.Core,
                userId: ''
            }
        },
        methods: {
        }
    }
</script>
